module.exports = __webpack_public_path__ + "static/media/XVG.cfbddc15.svg";